import { useDispatch } from 'react-redux';
import { setGameId, setMiddle, setHand, appendMiddle, setPlayerTurn, setSomethingHappend, reducePlayerCardCount, resetPlayerCardCount, setPlayersInitially, resetGameState } from '../store/gameSlice';
import { disconnectFromLobby } from '../store/lobbySlice';
import { resetSession } from '../store/gameSessionSlice';
import useGameMessageHandler from './useGameMessageHandler';
import { connect, disconnect, subscribe, unsubscribe } from '../services/ws-service';
import { useNavigate } from 'react-router-dom';
import { CardDto, DealHandDto } from './types/GameMessage';
import { GameStartingDto } from './types/StartGameMessage';

// Define types for payload (this will improve clarity and help with TypeScript validation)
interface PrivateMessagePayload {
  body: string;
}

const usePrivateMessageHandler = () => {
  const onGameMessageReceived = useGameMessageHandler();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onPrivateMessageReceived = (payload: PrivateMessagePayload) => {
    // Parse the message body once
    const message = JSON.parse(payload.body);

    console.log('%cWsContainer::onPrivateMessageReceived:::::::::::::::::::::::::' + payload.body, 'background-color: lightgreen');

    // Handle different statuses
    switch (message.status) {
      case 'START':
        // Handle "START" status
        dispatch(resetGameState());
        dispatch(resetSession());
        navigate('game');
        const gameStartingDto = message as GameStartingDto;
        subscribe(`/topic/public/game/${gameStartingDto.gameId}`, onGameMessageReceived);
        console.log("game id " + gameStartingDto.gameId);
        dispatch(setGameId({ gameId: gameStartingDto.gameId }));
        var firstplayer = gameStartingDto.team1.player1Order === 1 ? gameStartingDto.team1.player1 : gameStartingDto.team1.player2;
        console.log("firstPlayer  " + firstplayer);
        dispatch(setPlayerTurn({ player: firstplayer }));
        dispatch(setPlayersInitially({ players: getPlayers(gameStartingDto) }));
        console.log("players  " + message.players);
        break;

      case 'DEAL':
        // Handle "DEAL" status
        const dealHandDto = message as DealHandDto;
        dispatch(setHand({ hand: dealHandDto.cards }));
        dispatch(resetPlayerCardCount());
        break;

      case 'UNAUTHORIZED':
        // Handle "UNAUTHORIZED" status
        unsubscribe(message.topic);
        dispatch(disconnectFromLobby());
        break;

      default:
        console.warn('Unknown message status:', message.status);
        break;
    }
  };

  return onPrivateMessageReceived;
};

// Turn order is T1P1 -> T2P1 -> T1P2 -> T2P2 (Game.PlayerTurn on the backend), which is
// also the physical seating order around the table (partner opposite you, opponents left/right).
// GameBoard's per-viewer seat rotation (getPlayerLayout) indexes into this array assuming
// that exact order - do not "helpfully" regroup this by team, it breaks the seating layout.
function getPlayers(game: GameStartingDto): string[] {
  return [
    game.team1.player1,
    game.team2.player1,
    game.team1.player2,
    game.team2.player2,
  ];
}

export default usePrivateMessageHandler;
